/**
 * Safaqat 24's own registrations, shown in the footer's licence line.
 *
 * These are the platform's numbers (not a broker's or a listing's), and they
 * must be the real ones: REGA requires a platform to display its FAL licence,
 * and a wrong number on every page is worse than none. They are copied from the
 * documents the owner supplied on 2026-10-07 (served from public/licences/):
 *
 * - FAL licence for brokerage and marketing, REGA, no. 1200047312, issued
 *   22/07/2026, valid until 22/07/2027 (fal-licence-1200047312.pdf). Its QR
 *   opens the licence on REGA's e-services, which is the verify link below.
 * - Commercial registration, Ministry of Commerce, unified national number
 *   7052178840, issued 21/10/2025 (commercial-registration-7052178840.pdf).
 *   Its QR opens the record on the Saudi Business Center.
 *
 * Both are held by «شركة صفقات 24 ويب العقارية». Override per build with the
 * VITE_ variables. A licence only renders in production once its number is set;
 * in development an unset one shows where it will go. No VAT number was
 * supplied, so that row stays hidden.
 */

const env = import.meta.env;

const pick = (fromEnv: string | undefined, fallback: string) => (fromEnv ?? '').trim() || fallback;

export const PLATFORM_LICENCES = {
  /** The registered company name, exactly as on both documents. */
  legalName: 'شركة صفقات 24 ويب العقارية',
  /** FAL licence number issued by the Real Estate General Authority (REGA). */
  falLicenseNumber: pick(env.VITE_PLATFORM_FAL_LICENSE, '1200047312'),
  /** REGA's public page for the licence (what the certificate's QR opens); drives our QR code. */
  falVerifyUrl: pick(
    env.VITE_PLATFORM_FAL_VERIFY_URL,
    'https://eservicesredp.rega.gov.sa/public/OfficesBroker/LicenseDetails/Bml/08de586e-6e72-43ad-8276-e9b069eaba66',
  ),
  /** The licence certificate itself (public/licences). */
  falCertificateUrl: '/licences/fal-licence-1200047312.pdf',
  /** Commercial registration: the unified national number (الرقم الوطني الموحد), Ministry of Commerce. */
  crNumber: pick(env.VITE_PLATFORM_CR_NUMBER, '7052178840'),
  /** The Saudi Business Center's public page for the record (what the certificate's QR opens). */
  crVerifyUrl: pick(
    env.VITE_PLATFORM_CR_VERIFY_URL,
    'https://qr.saudibusiness.gov.sa/viewcr?nCrNumber=5pfSPBOSbmAh3WVK8Fzyxg==',
  ),
  /** The registration certificate itself (public/licences). */
  crCertificateUrl: '/licences/commercial-registration-7052178840.pdf',
  /** VAT registration number (الرقم الضريبي), ZATCA. Not supplied yet. */
  vatNumber: pick(env.VITE_PLATFORM_VAT_NUMBER, ''),
} as const;
